import { Component, OnInit } from "@angular/core";
import { NgZone } from "@angular/core";
import { ViewportScroller } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";

import { ScheduleService } from "./services/schedule.service";
import {
  AngularPageVisibilityStateEnum,
  OnPageVisibilityChange,
} from "angular-page-visibility";
import { DataService } from "./services/data.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    private ss: ScheduleService,
    private dataService: DataService,
    private ngZone: NgZone,
    private router: Router,
    private scroller: ViewportScroller,
  ) {
    (window as any).upd = {
      component: this,
      zone: this.ngZone,
      callF: () => this.ss.updateScheduleData(),
    };
  }

  getPageUrl() {
    return this.router.url.split("?")[0];
  }

  ngOnInit(): void {
    this.ss.initSchedule();
    this.dataService.getPageData();
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        setTimeout(() => this.scroller.scrollToAnchor("routerSection"), 0);
      }
    });
  }

  @OnPageVisibilityChange()
  pageVisibilityChange(visibilityState: AngularPageVisibilityStateEnum): void {
    this.ss.visibilityChange(visibilityState);
  }
}
